import { FilmSlateIcon as PhosphorFilmSlateIcon } from "@phosphor-icons/react/dist/ssr/FilmSlate";

import { createAppIcon } from "@/components/createAppIcon";

export const VideoIcon = /* @__PURE__ */ createAppIcon(PhosphorFilmSlateIcon);
